import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70d0bdff")

_pushScopeId("data-v-70d0bdff")
const _hoisted_1 = {
  key: 0,
  class: "content df-middle pr-8"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("100% First deposit Bonus")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_ctx.showBonus && _ctx.isLogin)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_t, {
          as: "p",
          path: "market_24",
          class: "mr-24 flex-1 c-white"
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/in",
          class: "btn primary sm df-middle f-bold deposit-btn"
        }, {
          default: _withId(() => [
            _createVNode(_component_t, {
              path: "market_25",
              custom: ""
            }, {
              default: _withId(({td}) => [
                _createTextVNode(_toDisplayString(td || 'Deposit'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Icon, {
              name: "caret-right",
              sm: "",
              class: "f-bold deposit-icon"
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
})